<button class="bg-lime-600 hover:bg-lime-500 rounded border border-lime-900 hover:border-lime-600 text-white"
    [ngClass]="{'py-3 px-4': isLarge, 'text-sm py-2 px-3': !isLarge, 'bg-gray-300 hover:bg-gray-300' : isDisabled}"
    [disabled]="isDisabled">
    <ng-content></ng-content>
</button>